<form [formGroup]="form" class="flex flex-col">
    <!-- <div formArrayName="scheduleHs" class="space-y-5">
        <div *ngFor="let scheduleH of scheduleHs().controls; let i = index"> -->
    <section class="w-full lg:w-9/12 xl:w-6/12">
        <h3 class="section-heading !mb-[10px]">Eligibility</h3>
        <app-application-form-field
            label="Eligibility Rule Description"
            [ellipsisLength]="messages.eligibilityRuleDescriptionHint.length"
            [tooltipMessage]="messages.eligibilityRuleDescriptionHint"
            [showTooltipIcon]="false"
        >
            <mat-form-field
                appearance="outline"
                class="w-full"
                [color]="
                    form.controls.eligibilityRuleNumber.invalid
                        ? 'warn'
                        : 'primary'
                "
            >
                <mat-label>Rule Section</mat-label>
                <input
                    title="Rule Section"
                    matInput
                    maxLength="50"
                    formControlName="eligibilityRuleNumber"
                    [matAutocomplete]="addAutocomplete"
                    [appRegexInput]="
                        scheduleHRegExPattern.RuleSectionCharacters
                    "
                />
                <mat-autocomplete
                    autoActiveFirstOption
                    #addAutocomplete="matAutocomplete"
                    [hideSingleSelectionIndicator]="true"
                >
                    @for (
                        eligibilityRule of filteredEligibilityRuleOptions;
                        track eligibilityRule.value
                    ) {
                        <mat-option [value]="eligibilityRule.value">{{
                            eligibilityRule.value
                        }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </app-application-form-field>

        <app-application-form-field
            label="Eligibility Activity Description"
            [ellipsisLength]="
                messages.eligibilityActivityDescriptionHint.length
            "
            [hintMessage]="messages.eligibilityActivityDescriptionHint"
            [tooltipMessage]="messages.eligibilityActivityDescriptionTooltip"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full"
                [color]="
                    form.controls.eligibleActivityDescription.invalid
                        ? 'warn'
                        : 'primary'
                "
            >
                <mat-label>Describe Activity</mat-label>
                <textarea
                    title="Describe Activity"
                    matInput
                    maxLength="255"
                    formControlName="eligibleActivityDescription"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    class="!h-40"
                ></textarea>
            </mat-form-field>
        </app-application-form-field>
    </section>

    <section class="w-full grid grid-cols-12 space-x-5">
        <div class="col-span-9 xl:col-span-6">
            <h3 class="section-heading !mb-[10px]">
                Extended Implementation (Slow Growth):
            </h3>
            <app-application-form-field
                label="Extended Implementation (Slow Growth)"
                class="w-full"
                [tooltipMessage]="messages.extendedImplementationTooltip"
                [showTooltipIcon]="true"
            >
                <mat-form-field
                    appearance="outline"
                    class="w-full"
                    [color]="
                        form.get('extendedImplementation')?.invalid
                            ? 'warn'
                            : 'primary'
                    "
                >
                    <mat-label>New or Modified Implementation Plan?</mat-label>
                    <mat-select
                        formControlName="extendedImplementation"
                        required
                    >
                        @for (
                            yesNoOption of yesNoOptions;
                            track yesNoOption.value
                        ) {
                            <mat-option [value]="yesNoOption.value">{{
                                yesNoOption.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </app-application-form-field>
        </div>
        @if (form.controls.extendedImplementation.value) {
            <div class="col-span-3 2xl:col-span-2 pt-9">
                <app-attachment-required-button class="w-full" />
            </div>
        }
    </section>

    <div class="space-y-5">
        <section class="space-y-[5px]">
            <div class="flex space-x-2 items-center mb-[5px]">
                <h3 class="section-heading !mb-0">Associated Call Signs</h3>

                @if (callSignsFormArray.invalid) {
                    <img src="assets/svg/error_icon.svg" alt="Error Icon" />
                }
            </div>

            @if (!isReadOnly()) {
                <button
                    color="primary"
                    class="!rounded-full"
                    (click)="addCallSignToGrid()"
                    type="button"
                    mat-flat-button
                >
                    Add Call Sign
                </button>
            }
            <div>
                {{ gridTooltipMessages.headerTooltipInfoNote }}
            </div>
            <ag-grid-angular
                [context]="
                    initializeGridContext(
                        scheduleHAdditionalInformationGridType.AssocCallSigns
                    )
                "
                [rowData]="
                    rowData[
                        scheduleHAdditionalInformationGridType.AssocCallSigns
                    ]
                "
                [gridOptions]="assocCallSignGridOptions"
                (gridReady)="
                    onGridReady(
                        $event,
                        scheduleHAdditionalInformationGridType.AssocCallSigns
                    )
                "
                class="ag-theme-quartz h-[266px] max-w-3xl"
            >
            </ag-grid-angular>
        </section>

        <section class="space-y-[5px]">
            <div class="flex space-x-2 items-center mb-[5px]">
                <h3 class="section-heading !mb-0">Control Points</h3>

                @if (controlPointsFormArray.invalid) {
                    <img src="assets/svg/error_icon.svg" alt="Error Icon" />
                }
            </div>

            @if (!isReadOnly()) {
                <button
                    color="primary"
                    class="!rounded-full"
                    (click)="addControlPointToGrid()"
                    type="button"
                    mat-flat-button
                >
                    Add Control Point
                </button>
            }
            <div>
                {{ gridTooltipMessages.headerTooltipInfoNote }}
            </div>
            <ag-grid-angular
                [context]="
                    initializeGridContext(
                        scheduleHAdditionalInformationGridType.AssocControlPoints
                    )
                "
                [rowData]="
                    rowData[
                        scheduleHAdditionalInformationGridType
                            .AssocControlPoints
                    ]
                "
                [gridOptions]="assocControlPointGridOptions"
                (gridReady)="
                    onGridReady(
                        $event,
                        scheduleHAdditionalInformationGridType.AssocControlPoints
                    )
                "
                class="ag-theme-quartz h-[300px] w-full"
            >
            </ag-grid-angular>
        </section>
    </div>
    <!-- </div>
    </div> -->
</form>
